export const FROM_ISO_TIME = /^PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?$/;

export const NAME_PATTERN = '^[A-Za-z]+';
export const EMAIL_PATTERN = '[a-zA-Z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$';
export const PHONE_NUMBER_PATTERN = /^\+?\d[\d -]{8,19}\d$/;
